<template>
  <v-container id="extended-tables" fluid tag="section">
    <base-v-component heading="" link="componetns/simple-tables" />

    <base-material-card color="success" icon="mdi-clipboard-text" inline title="Grupos" class="px-5 py-3 mb-5">
      <v-row>
        <v-col cols="12" md="6">
          <v-select v-model="urbanizacion" outlined :items="urbanizaciones" label="Urbanizaciones" item-text="name"
            item-value="id" persistent-hint return-object single-line v-on:change="listarEdificios()"></v-select>
        </v-col>
        <v-col cols="12" md="6">
          <v-select v-model="edificio" outlined :items="edificios" label="Edificios" item-text="name" item-value="id"
            persistent-hint return-object single-line v-on:change="listar()"></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" class="mt-10">
          <v-data-table :headers="headers" :items="Properties" sort-by="calories" class="elevation-1" :search="search"
            :loading="loadingTable" loading-text="Cargando... Por favor esperar">
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Propiedades</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
                  hide-details></v-text-field>

                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="500px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on" @click="editedIndex = -1">
                      Nueva Propiedad<caption></caption>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-toolbar dark color="primary">
                      <v-btn icon dark @click="close">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-toolbar-title>{{ formTitle }} </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                      <v-form ref="form" v-model="validForm">
                        <v-container>
                          <div class="font-weight-bold text-center lime accent-3 px-4 py-2 rounded">
                            Datos del propietario
                          </div>
                          <v-divider> </v-divider>
                          <v-row>
                            <v-col cols="12" sm="12" md="12">
                              <v-text-field v-model="Propietario" label="Nombre del propietario" required
                                :rules="requiredRule"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6" md="6">
                              <v-autocomplete v-model="TipoDocuemnto" :items="TipoDocuemntos" dense filled
                                label="Tipo Documento" clearable required :rules="requiredRule"></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field v-model="NoDocumento" label="No Documento" required
                                :rules="requiredRule"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field v-model="Email" label="Email" required :rules="requiredRule"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field v-model="Telefono" label="Telefono" required
                                :rules="requiredRule"></v-text-field>
                            </v-col>
                          </v-row>
                          <div class="font-weight-bold text-center lime accent-3 px-4 py-2 rounded">
                            Datos de la propiedad
                          </div>
                          <v-divider></v-divider>
                          <v-row>
                            <v-col cols="12" sm="6" md="6">
                              <v-autocomplete v-model="Tipo" :items="Tipos" dense filled label="Tipo de propiedad"
                                clearable required :rules="requiredRule"></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field v-model="No" label="No de propiedad" required
                                :rules="requiredRule"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field v-model="Piso" label="Piso" required :rules="requiredRule" type="number"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field v-model="Area" label="Area" required :rules="requiredRule" type="number"></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-form>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="secondary" @click="close"> Cerrar </v-btn>
                      <v-btn color="primary" @click="guardar()"> Guardar </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5">Esta seguro de eliminar datos?</v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                      <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" large @click="editar(item)">
                    <v-icon dense color="secondary">mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" large @click="deleteItem(item)">
                    <v-icon dense color="primary">mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="initialize"> Recargar </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </base-material-card>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  name: "DashboardExtendedTables",

  data: () => ({
    selectedId: '',
    dialog: false,
    dialogDelete: false,
    headers: [
      { text: "Propietario", value: "owner" },
      { text: "Tipo", value: "propertyType" },
      { text: "No", value: "unitNumber" },
      { text: "Piso", value: "floor" },
      { text: "Area", value: "area" },
      { text: "Tipo Doc", value: "documentType" },
      { text: "No Doc", value: "documentNo" },
      { text: "Email", value: "email" },
      { text: "Telefono", value: "phone" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    Properties: [],
    editedIndex: -1,
    //medicamento: "",
    //presentacion: "",
    //literatura: "",
    search: "",
    loadingTable: false,
    snackbar: false,
    text: "",
    timeout: 6000,
    urbanizaciones: [],
    urbanizacion: [],
    edificios: [],
    edificio: [],
    //popup
    Propietario: "",
    Tipo: "",
    Tipos: ["Casa", "Apartamento", "Local", "Oficina"],
    No: "",
    Piso: "",
    Area: "",
    TipoDocuemnto: "",
    TipoDocuemntos: ["Cedula", "RUC", "Pasaporte", "Otro"],
    NoDocumento: "",
    Email: "",
    Telefono: "",
    id: "",
    validForm: false,
    requiredRule: [(v) => !!v || 'Este campo es obligatorio'],
   
  }),

  computed: {
    
    formTitle() {
      return this.editedIndex === -1 ? "Nueva propiedad" : "Editar propiedad";
    },
    
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 6000);

      this.loader = null;
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.listarUrbanizaciones();
    },
    listarUrbanizaciones() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Communities", configuracion)
        .then(function (response) {
          me.urbanizaciones = response.data;
          me.Properties = []; //limpiar propiedades cuando selecciono otra urbanizacion
          console.log(response.data);
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        });
    },
    listarEdificios() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.edificios = [];
      axios
        .get("api/Buildings/BuildingByCommunity/" + me.urbanizacion.id, configuracion)
        .then(function (response) {
          me.edificios = response.data;
          me.Properties = []; //limpiar propiedades cuando selecciono otra urbanizacion
          console.log(response.data);
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        });
    },
    listar() {
      let me = this;

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.loadingTable = true;
      me.Properties = [];
      axios
        .get("api/Properties/PropertiesByBuilding/" + me.edificio.id, configuracion)
        .then(function (response) {
          me.Properties = response.data;
          //change to string bool value
          me.loadingTable = false;
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        }
        );
    },
    guardar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      console.log("Entre antes de guardar");
      if (this.$refs.form.validate()) {
        if (me.editedIndex > -1) {
          //edit
          console.log("editar propiedad");
          axios
            .post(
              "api/Properties/UpdateProperty",
              {
                id: me.id,
                Building_uq: me.edificio.id,
                UnitNumber: me.No,
                Floor: me.Piso,
                Owner: me.Propietario,
                Area: me.Area,
                PropertyType: me.Tipo,
                Email: me.Email,
                Phone: me.Telefono,
                DocumentNo: me.NoDocumento,
                DocumentType: me.TipoDocuemnto
              },
              configuracion
            )
            .then(function (response) {
              me.listar();
              me.$refs.form.reset();
              console.log(response);
            })
            .catch((err) => {
              if (err.response.status == 401) {
                this.$store.dispatch("salir");
              }
            });
        } else {
          console.log("crear propiedad");
          axios
            .post(
              "api/Properties/InsertProperty",
              {
                Building_uq: me.edificio.id,
                UnitNumber: me.No,
                Floor: me.Piso,
                Owner: me.Propietario,
                Area: me.Area,
                PropertyType: me.Tipo,
                Email: me.Email,
                Phone: me.Telefono,
                DocumentNo: me.NoDocumento,
                DocumentType: me.TipoDocuemnto
              },
              configuracion
            )
            .then(function (response) {
              me.listar();
              me.$refs.form.reset();
              console.log(response);
            })
            .catch((err) => {
              if (err.response.status == 400) {
                me.snackbar = true;
                me.text = err.response.data.errors;
              }
              if (err.response.status == 401) {
                this.$store.dispatch("salir");
              }
            });
        }
        me.close();
      }
      
    },
  
    deleteItem(item) {
      let me = this;
      me.selectedId = item.id;
      console.log(item);
      me.dialogDelete = true;
    },
    deleteItemConfirm() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Properties/Delete/" + me.selectedId, configuracion)
        .then(function (response) {
          me.dialogDelete = false;
          if (response.data[0]["error"]) {
            me.snackbar = true;
            me.text = response.data[0]["messagge"];
          }
          me.listar();
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        }
        );
    },
   
    editar(item) {
      let me = this;
      me.id=item.id;
      me.Propietario = item.owner;
      me.Tipo = item.propertyType;
      me.No = item.unitNumber;
      me.Piso = item.floor;
      me.Area = item.area;
      me.TipoDocuemnto = item.documentType;
      me.NoDocumento = item.documentNo;
      me.Email = item.email;
      me.Telefono = item.phone;
     
      me.editedIndex = 1;
      me.dialog = true;
    },
    close() {
      let me = this;
      me.dialog = false;
     
    },
    closeDelete() {
      this.dialogDelete = false;
     
    },
  },
};
</script>